import React, {Component} from 'react';
import {getColorStyles, style as commonStyles} from './style';
import { appendZero, getFormat12, format12to24, format24to12, isMousePressed } from './utils';

export default class TimePicker extends Component {

/*  static defaultProps = {
    keyName : 'react-theme-style'
  };*/

  constructor(props) {
    super(props);
    let format12 = '';
    if (this.props.time) {
    //   console.log(this.props.time);
      let time = this.props.time.split(':');
      format12 = format24to12(Number(time[0]), Number(time[1]));
      // console.log(time,this.props.time);
    }
    // console.log(format12);
    this.state = {
      toShow : false,
      time   : {
        format12 : format12,
        format24 : ''
      },
      change: false
    };
  }

  componentWillMount() {
    this.addStyles();
    // this.interv();
  }


  componentWillReceiveProps(nextProps) {
    let format12 = '';
    let format24 = '';

    if (nextProps.time) {
      let temp = nextProps.time.split(':');
      format12 = format24to12(Number(temp[0]), Number(temp[1]));
      format24 = nextProps.time;
    }

    this.setState({
      time : {
        format12,
        format24
      }
    });
  }

  addStyles() {
    const commonSelector = 'react-timepicker-common-style';
    const themeSelector = this.getThemeSelector(this.props.theme, this.props.color1);
    const {theme, color1, headerColor} = this.props;
    let head = document.head || document.getElementsByTagName('head')[0];

    if (!document.getElementById(commonSelector)) {
      let style = document.createElement('style');
      style.type = 'text/css';
      style.id = commonSelector;

      if (style.styleSheet) {
        style.styleSheet.cssText = commonStyles;
      } else {
        style.appendChild(document.createTextNode(commonStyles));
      }

      head.appendChild(style);
    }

    if (!document.getElementById(themeSelector)) {
      let themeStyles = getColorStyles({
        themeSelector,
        theme,
        color1,
        headerColor
      });

      let style = document.createElement('style');
      style.type = 'text/css';
      style.id = themeSelector;

      if (style.styleSheet) {
        style.styleSheet.cssText = themeStyles;
      } else {
        style.appendChild(document.createTextNode(themeStyles));
      }
      head.appendChild(style);
    }
  }

  // utils
  removeEventListener() {
    window.removeEventListener('keydown', this.handleKeyPress);
  }

  addEventListener() {
    window.addEventListener('keydown', this.handleKeyPress);
  }

  // handlers

  handleKeyPress = (e) => {
    switch (e.which) {
    case 13 : 
      if (e.target !== this.closeButton) {
        this.handleSet();
    }
      break;

    case 27 : 
      this.toggleToShow(false);
      break;

    case 38 :  // up
      this.state.toShowHourContainer ?
        this.setHour(((this.state.degree + 30) % 360) || 360)
        :
        this.setMinute(((this.state.degree + 6) % 360) || 360);
    
      break;

    case 40 :  // down
      this.state.toShowHourContainer ?
        this.setHour(((this.state.degree - 30) % 360) || 360)
        :
        this.setMinute(((this.state.degree - 6) % 360) || 360);
    
      break;
    default: break;
    }
  };

  handleMove = (event) => {
    event.preventDefault();
    if (isMousePressed(event)) return;
    // if(!this.state.toShowHourContainer) {
    //   this.changeClock(event.nativeEvent.clientX, event.nativeEvent.clientY);
    // }
    this.changeClock(event.nativeEvent.clientX, event.nativeEvent.clientY);
  };


  handleTouchMove = (event) => {
    event.preventDefault();
    this.changeClock(event.changedTouches[0].clientX, event.changedTouches[0].clientY);
  };
  
  handleTouchUp = (event) => {
    if (event.target === this.mask) return;
    this.changeClock(event.changedTouches[0].clientX, event.changedTouches[0].clientY);
  };

  handleMoveUp = (event) => {
    if (event.target === this.mask) return;
    this.changeClock(event.nativeEvent.clientX, event.nativeEvent.clientY,true);
  };
  
  changeClock = (clientX, clientY, status = false) => {
    const x = clientX - this.containerPos.x;
    const y = clientY - this.containerPos.y;
    const temp = this.state.toShowHourContainer ? this.setHour(this.getDegree(x, y)) : this.setMinute(this.getDegree(x, y));
    // console.log('status',status && Object.keys(temp).length && this.state.toShowHourContainer);
    if(status && Object.keys(temp).length && this.state.toShowHourContainer) {
      this.toggleHourOrMinuteContainer(false);
    }
  };

  toggleHourOrMinuteContainer(toShowHourContainer) {
    let { degree, selectedIndexDegree } = toShowHourContainer ? this.getSelectedIndexDegreeAndDegreeForHour(Number(this.state.hour)) : this.getSelectedIndexDegreeAndDegreeForMinute(Number(this.state.minute));
    this.setState({
      toShowHourContainer,
      degree,
      selectedIndexDegree
    });
  }

  toggleAmPm(isAmSelected) {
    if(this.checkHour(this.state.hour,isAmSelected) && this.checkMinute(this.state.minute,isAmSelected)) {
      this.setState({
        isAmSelected
      });
    }
  }

  handleFocus = (e, time = this.props.time)=> {
    // console.log(e,time);
    if(e !== null) {
      e.preventDefault();
    }
    let format24 = time;
    let {hour, minute, degree, selectedIndexDegree, isAmSelected} = this.getInitialConfig(format24,this.state.toShowHourContainer);
    if(e === null) {
      this.setState({
        hour,
        minute,
        selectedIndexDegree,
        degree,
      }, () => {
        this.init();
      });

    } else {
      this.toggleToShow();
      this.setState({
        degree,
        hour,
        minute,
        toShowHourContainer : true,
        selectedIndexDegree,
        isAmSelected
      }, () => {
        this.init();
      });
    }
  };
  
  toggleToShow(toShow = true) {
    this.setState({
      toShow
    });

    toShow ? this.addEventListener() : this.removeEventListener();
  }

  handleSet = () => {
    let allFormat = this.getTime(Number(this.state.hour), Number(this.state.minute), this.state.isAmSelected);
    this.setState({
      time : allFormat
    });

    this.toggleToShow(false);
    this.toggleHourOrMinuteContainer(true);
    this.inputField.blur();
    this.props.onSet(allFormat);
  };

  // functionality
  init() {
    this.center = {
      x : 130,
      y : 130
    };

    const maskPosition = this.mask.getBoundingClientRect();
    this.containerPos = {
      y : maskPosition.top,
      x : maskPosition.left
    };
    this.basePoint = {
      x : 130,
      y : 0
    };
  }

  getThemeSelector(theme, color1) {
    let _color1 = color1;
    if (color1 && color1.indexOf('#') === 0) {
      _color1 = color1.substr(1);
    }

    if (theme) {
      if (color1) {
        return theme.split(' ').join('-') + _color1;
      }
      return theme.split(' ').join('-');
    }

    if (_color1) {
      return _color1;
    }

    return 'react-time-picker-theme';
  }

  getHour(val) {
    return appendZero((val % 12) || '12');
  }

  getMinute(val) {
    return appendZero((val % 60) || '0');
  }

  getInitialConfig(time,status = true) {
    // console.log(time,status);
    let date = new Date();
    time = time ? time : date.getHours() + ':' + date.getMinutes();
    const temp = time.split(':');
    const hour24 = Number(temp[0]);
    const minute24 = Number(temp[1]);
    const {degree, selectedIndexDegree} = status?this.getSelectedIndexDegreeAndDegreeForHour(hour24):this.getSelectedIndexDegreeAndDegreeForMinute(minute24);

    return {
      date: this.props.date,
      hour         : this.getHour(hour24),
      minute       : this.getMinute(minute24),
      degree,
      selectedIndexDegree,
      isAmSelected : Number(temp[0]) < 12
    };
  }

  getSelectedIndexDegreeAndDegreeForHour(val) {
    const degree = (val * 30) % 360;
    return {
      selectedIndexDegree : this.getSelectedIndexDegree(degree),
      degree
    };
  }

    show = (status) => {
        if(status && !this.state.toShow) {
            document.getElementById('customTimer').focus();
        } else if(!status && this.state.toShow) {
            this.toggleToShow(false);
            this.inputField.blur();        
        }
    }

  getSelectedIndexDegreeAndDegreeForMinute(val) {
    /* const degree = val * 6 || 360; // why?
    const i = (degree / 6) % 5;
    return {
      selectedIndexDegree : i ? -1 : this.getSelectedIndexDegree(degree),
      degree
    };
    */
    const degree = (val * 6) % 360; // why?
    // const i = (degree / 6) % 5;
    return {
      selectedIndexDegree : this.getSelectedIndexDegree(degree),
      degree
    };
  }

  getSelectedIndexDegree(degree) {
    return (degree / 30) % 12;
  }


  getDegree(offsetX, offsetY) {
    const x = offsetX - this.center.x;
    const y = offsetY - this.center.y;
    const cx = this.basePoint.x - this.center.x;
    const cy = this.basePoint.y - this.center.y;
    const atan = Math.atan2(cx, cy) - Math.atan2(x, y);
    return (atan * 57.29577951308232) % 360;
  }

  getClock = (className) => {
    const hours = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
    const minutes = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];
    const hoursOrMinutes = this.state.toShowHourContainer ? hours : minutes;
    return hoursOrMinutes.map((i, j) => {
      return (
        <span
          key={i}
          className={`circle${this.state.toShowHourContainer?(this.checkHour(i)?'':' disable'):(this.checkMinute(i)?'':' disable')}${this.state.selectedIndexDegree === j ? ` selected ${className}` : ''}`}
        >
          {i}
        </span>
      );
    });
  };

  getTime(hour, minute, isAmSelected) {
    const format12 = getFormat12(hour, minute, isAmSelected);
    const format24 = format12to24(hour, minute, isAmSelected);
    const hours = isAmSelected?hour === 12?0:hour:hour === 12?hour:hour+12;
    return {
      format12,
      format24,
      hours,
      minute,
      zone: isAmSelected?'AM':'PM'
    };
  }

  setMinute(degree) {
    /* let toRound = degree % 6;
    toRound < 3 ? degree -= toRound : degree += (6 - toRound); */
    const base = Math.round(degree / 6);
    degree = base * 6;
    const minute = this.getMinute(base);
    const selectedIndexDegree = this.getSelectedIndexDegree(degree);
    const toReturn = {};
    // console.log(minute,this.checkMinute(minute));
    if(this.checkMinute(minute) ) {
      toReturn.degree = degree;
      toReturn.minute = minute;
      toReturn.selectedIndexDegree = selectedIndexDegree;
    }
    this.setState(toReturn);
    return toReturn;
  }

  checkDate = () => {
    const current = this.getDayMonthYear();
    const res = this.getDayMonthYear(this.props.date);
    return res > current;
  }

  getDayMonthYear = (val = new Date()) => +new Date(val).setHours(23, 59, 59, 999);

  checkHour = (hour, isAmSelected = this.state.isAmSelected) => {
    // console.log(this.props);
    if(this.checkDate()) {
      return true
    }
    hour = parseInt(hour);
    const { minute } = this.state;
    let minutes = parseInt(minute);
    const currentHour = new Date().getHours();
    const currentMinute = new Date().getMinutes();
    const gethour = isAmSelected?hour === 12?0:hour:hour+12;
    return currentHour < gethour || (currentHour === gethour && currentMinute < minutes)
  }

  interv = () => {
    setInterval(() => {
      if(!this.checkMinute(this.state.minute)) {
        const currentMinute = new Date().getMinutes();
        let minute = currentMinute+this.props.diff;
        let temp = {}
        if(minute === 60) {
          temp.hour = this.getHour(parseInt(this.state.hour) + 1)
          minute = 0;
        }
        temp.minute = this.getMinute(minute)
        if(!this.state.toShowHourContainer) {
          let { degree, selectedIndexDegree } = this.getSelectedIndexDegreeAndDegreeForMinute(minute);
          temp.degree = degree;
          temp.selectedIndexDegree = selectedIndexDegree;
        } else if(temp.hasOwnProperty('hour')) {
          let { degree, selectedIndexDegree } = this.getSelectedIndexDegreeAndDegreeForHour(temp.hour);
          temp.degree = degree;
          temp.selectedIndexDegree = selectedIndexDegree;
        }
        this.setState(temp)
      }
    },1000);
  }

  checkMinute = (minute, isAmSelected = this.state.isAmSelected) => {
    if(this.checkDate()) {
      return true
    }

    minute = parseInt(minute);
    const { hour } = this.state;
    const currentHour = new Date().getHours();
    const currentMinute = new Date().getMinutes();
    const gethour = isAmSelected?parseInt(hour) === 12?0:parseInt(hour):parseInt(hour)+12;
    return currentHour < gethour || (currentHour === gethour && minute > (currentMinute + this.props.diff))
  } 

  setHour(degree) {
    /* let toRound = degree % 30;
    toRound < 15 ? degree -= toRound : degree += (30 - toRound);*/
    const base = Math.round(degree / 30);
    degree = base * 30;
    const hour = this.getHour(base);
    const selectedIndexDegree = this.getSelectedIndexDegree(degree);
    let toReturn = {};
    if(this.checkHour(hour) ) {
      toReturn.degree = degree;
      toReturn.hour = hour;
      toReturn.selectedIndexDegree = selectedIndexDegree;
    }
    this.setState(toReturn);
    return toReturn;
  }

  inputEvent = (e, status) => {
    // console.log(e.which,e.target.value);
    // console.log(e.target.);
    // const time = status === 'hour'?12:59;
    let min = 48;
    // if(status === 'hour' && e.target.value.length === 1 && Number(e.target.value) !== 1) {
    //   min = 49;
    // }
    if (e.which === 32) {
      e.preventDefault();
    // } else if(e.target.value.length) {
    //   let number = Number(e.target.value)*10;
    //   // console.log('keyPress',number,'--------',number+(e.which - 48), time,'-----',number+(e.which - 48) > time);
    //   if(number+(e.which - 48) > time ) {
    //     e.preventDefault();
    //   }
    } else if (e.which < min || e.which > 57) {
      e.preventDefault();
    }
  }

  setResponse = (e,status) => {
    if(status === 'hour') {
      if(Number(e.target.value) <= 12) {
        this.setState({ hour: e.target.value });
      }
    } else {
      if(Number(e.target.value) <= 59) {
        this.setState({ minute: e.target.value });
      }
    }
    this.setState({ change: true });
  }

  setResponseOnBlur = (e,status) => {
    let hour = this.state.hour;
    let minute = this.state.minute;
    if(status === 'hour') {
      hour = Number(e.target.value);
      if(this.state.hour.length < 2) {
        this.setState({ hour: this.getHour(hour)});
      }
    } else {
      minute = Number(e.target.value);
    }
    if(!this.state.isAmSelected) {
      hour = Number(hour)+12;
    }
    // console.log('hour:minute',hour+':'+minute);
    if(this.state.change) {
      if(this.state.toShowHourContainer) {
        this.toggleHourOrMinuteContainer(false);
      } else {
        this.handleFocus(null,hour+':'+minute);
      }
      this.setState({ change: false });
    }
  }


  getBody() {
    if (!this.state.toShow) return false;
    const themeSelector = this.getThemeSelector(this.props.theme, this.props.color1);
    const primaryColorColorClassName = `react-timepicker-primary-color-color-${themeSelector}`;
    const primaryColorBackgroundClassName = `react-timepicker-primary-color-background-${themeSelector}`;
    const backgroundColorClassName = `react-timepicker-background-color-${themeSelector}`;
    return (
      <div>
        <div
          className="timepicker-backdrop"
          onClick={this.toggleToShow.bind(this, false)}
        />

        <div className="timepicker-modal">
          <header className={`timepicker-header ${backgroundColorClassName}`}>
            <div className="timepicker-time-container">
              <span
                className={`text-shadow ${!this.state.toShowHourContainer ? 'is-not-selected' : ''}`}
                onClick={this.toggleHourOrMinuteContainer.bind(this,true)}
              >
                <input className="time_input" type="text" maxLength="2" value={this.state.hour} onKeyPress={(el) => this.inputEvent(el, 'hour')} onChange={el => this.setResponse(el,'hour')} onBlur={el => this.setResponseOnBlur(el,'hour')}/>
                {/* {this.state.hour} */}
              </span>
              <span className="text-shadow">:</span>
              <span
                className={`text-shadow ${this.state.toShowHourContainer ? 'is-not-selected' : ''}`}
                onClick={this.toggleHourOrMinuteContainer.bind(this,false)}
              >
                <input className="time_input" type="text" onFocus={() => this.state.toShowHourContainer?this.toggleHourOrMinuteContainer(false):null } maxLength="2" value={this.state.minute} onKeyPress={(el) => this.inputEvent(el, 'minute')} onChange={el => this.setResponse(el,'minute')} onBlur={el => this.setResponseOnBlur(el,'minute')}/>
                {/* {this.state.minute} */}
              </span>
            </div>
            <div className="timepicker-am-pm-container">
              <input
                className={`am-pm-input ${this.checkHour(this.state.hour,!this.state.isAmSelected) && this.checkMinute(this.state.minute,!this.state.isAmSelected)?'':'disable'}`}
                type="radio"
                id="am"
                name="am-pm"
                value="am"
                checked={this.state.isAmSelected}
                onChange={this.toggleAmPm.bind(this, true)}
              />
              <label className={`am-pm-label ${this.checkHour(this.state.hour,!this.state.isAmSelected) && this.checkMinute(this.state.minute,!this.state.isAmSelected)?'':'disable'}`} htmlFor="am">AM</label>
              <input
                className="am-pm-input"
                type="radio"
                id="pm"
                name="am-pm"
                value="pm"
                checked={!this.state.isAmSelected}
                onChange={this.toggleAmPm.bind(this, false)}
              />
              <label className="am-pm-label" htmlFor="pm">PM</label>
            </div>
          </header>

          <main className="timepicker-main">
            <div
              className="hours-container"
              ref={(ref) => {this.mask = ref;}}
              onTouchMove={this.handleTouchMove}
              onTouchEnd={this.handleTouchUp}
              onMouseMove={this.handleMove}
              onMouseUp={this.handleMoveUp}
            >
              <div
                className={`${primaryColorBackgroundClassName} hand`}
                style={{
                  transform       : `rotate(${this.state.degree - 90}deg)`,
                  WebkitTransform : `rotate(${this.state.degree - 90}deg)`
                }}
              >
                &nbsp;
              </div>
              {this.getClock(primaryColorBackgroundClassName)}
            </div>
          </main>
          <footer>
            <button
              type="button"
              className={`${primaryColorColorClassName} timepicker-button close`}
              onClick={this.toggleToShow.bind(this, false)}
              ref={(ref) => {this.closeButton = ref;}}
            >
              Close
            </button>
            <button
              type="button"
              className={`${primaryColorBackgroundClassName} timepicker-button`}
              onClick={this.handleSet}
            >
              Set
            </button>
          </footer>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="timepicker-container">
        <input
            // className="formInput"
            readOnly
            type="text"
            id= "customTimer"
            placeholder={this.props.placeholder}
            className={`formInput ${this.props.className}`}
            value={this.state.time.format12}
            onFocus={this.handleFocus}
            ref={(ref) => {this.inputField = ref;}}
            style={this.props.style}
        />
        {this.getBody()}
      </div>
    );
  }
}